import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ExpenseEntry } from '../state-man/models/expense-entry.model';
import { LoggerService } from './logger.service';
import { UiService } from './ui.service';

@Injectable({
  providedIn: 'root'
})
export class ExpenseEntryService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  public async getMine () : Promise<ExpenseEntry[] | null> {   
    try {      
      const ret = await this.apiService.apiReturnsAny('get', 'expense_entry/mine/')          
      const expense_entries = (ret && Array.isArray(ret)) ? ExpenseEntry.buildMany(ret) : null

      if (!expense_entries) return null
      return expense_entries      
    } catch (error) {
      LoggerService.log(error + 'expense_entry/mine')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }  


  public async addExpenseEntry(expense_entry: ExpenseEntry) : Promise<ExpenseEntry | null> {
    try {
      const body = expense_entry
      const obj = await this.apiService.apiReturnsAny('post', 'expense_entry/', body, 'application/json')    
      return obj
    } catch (error) {
      LoggerService.log(error + 'post expense_entry/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }   

  public async updateExpenseEntry(expense_entry: ExpenseEntry) : Promise<ExpenseEntry | null> {
    try {          
      const body = expense_entry
      const obj = await this.apiService.apiReturnsAny('put', 'expense_entry/' + expense_entry.id, body, 'application/json')         
      return obj      
    } catch (error) {
      LoggerService.log(error + 'put expense_entry/')    
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }

  public async deleteExpenseEntry(expense_entry: ExpenseEntry) : Promise<any> {
    try {
      const ret = await this.apiService.apiReturnsAny('delete', 'expense_entry/' + expense_entry.id)               
      return ret
    } catch (error) {
      LoggerService.log(error + 'delete expense_entry/')    
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }  
}
